import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vehicule } from 'src/app/user/user.model';

@Component({
    selector: 'app-vehicule-modal',
    templateUrl: './vehicule-modal.component.html',
    styleUrls: ['./vehicule-modal.component.scss'],
})
export class VehiculeModalComponent implements OnInit {
    vehiculeForm: FormGroup;
    currentYear: number = new Date().getFullYear() + 1;
    validate = false;
    modalView = 0;
    vehicle: Vehicule;

    @Output() saveFnc = new EventEmitter<Vehicule>();

    constructor(
        public dialogRef: MatDialogRef<VehiculeModalComponent>,
        private formBuilder: FormBuilder,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.modalView = data.value;
        this.vehicle = { ...data.vehicle };
    }

    ngOnInit(): void {
        this.vehiculeForm = this.formBuilder.group({
            make: ['', Validators.required],
            model: ['', Validators.required],
            plate: ['', Validators.required],
            year: ['', [Validators.required, Validators.min(1900), Validators.max(this.currentYear)]],
        });
    }

    get f(): { [key: string]: AbstractControl } {
        return this.vehiculeForm.controls;
    }
    closeClick(): void {
        this.dialogRef.close({ event: 'Cancel' });
    }

    save() {
        this.validate = true;

        if (this.vehiculeForm.invalid) {
            return;
        }
        this.dialogRef.close({
            event: 'Save',
            data: {
                id: this.vehicle.id ? this.vehicle.id : -1,
                model: this.vehiculeForm.value.model,
                year: this.vehiculeForm.value.year,
                make: this.vehiculeForm.value.make,
                plate: this.vehiculeForm.value.plate,
                favorite: this.vehicle.favorite,
            },
        });
    }

    saveDelete() {
        this.dialogRef.close({
            event: 'Save',
            data: { id: this.vehicle.id },
        });
    }
}
